export enum LayerTypeEnum {
  Group = 'Group',
  MapServer = 'MapServer',
  GeoJson = 'GeoJson',
  VectorTileServer = 'VectorTileServer',
  FeatureServer = 'FeatureServer',
  WMS = 'WMS',
  WMTS = 'WMTS',
  WFS = 'WFS',
  KML = 'KML',
  SubServer = 'SubServer'
}
